module.exports = __webpack_public_path__ + "img/p6.9be298a8.jpg";